/* Nualï cart drawer — real Shopify cart (Ajax API). Same look as the validated mockup. */
(function () {
  var cd = document.getElementById('cd');
  var N = window.NU || {}, P = N.products || {}, CUR = N.cur, R = N.routes || {};
  var root = (R.root || '/').replace(/\/?$/, '/');
  var state = { items: [], item_count: 0, total_price: 0, original_total_price: 0 }, tEnd = 0, tId = 0, last;
  function $(id) { return document.getElementById(id); }
  function money(cents) { return N.money(cents / 100); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function api(url, body) {
    return fetch(url, { method: body ? 'POST' : 'GET', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: body ? JSON.stringify(body) : undefined })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); });
  }
  function isProt(it) { return N.prot && it.variant_id === N.prot.id; }
  function keyOf(it) { for (var k in P) if (P[k] && P[k].pid === it.product_id) return k; return null; }
  /* subscription renewal in the cart: 1 pack = 30 days, 2 packs = 2 months, 4 packs = 4 months (Theme settings > Livraison estimée & abonnement) */
  function renewTxt(x) {
    if (N.renewCart === false || !x.selling_plan_allocation) return null;
    var q = 0, k = keyOf(x), v = k && P[k] && P[k].v;
    if (v) for (var n in v) if (v[n] && v[n].id === x.variant_id) q = +n;
    q = q || parseInt(x.variant_title, 10) || 1;
    return N.tx(q >= 4 ? 'Renews in 4 months' : q >= 2 ? 'Renews in 2 months' : 'Renews in 30 days');
  }
  function count() { return state.items.reduce(function (s, x) { return s + (isProt(x) ? 0 : x.quantity * (parseInt(x.variant_title, 10) || 1)); }, 0); }
  function setCount() { var n = count(); document.querySelectorAll('#cartN').forEach(function (c) { c.textContent = n; }); }
  function refresh(openIt) {
    return api(root + 'cart.js').then(function (c) { state = c; render(); if (openIt) open(); });
  }
  function err(msg) { var e = $('cdErr'); if (!e) { if (msg) alert(msg); return; } e.textContent = msg || ''; e.hidden = !msg; }
  function add(items) {
    err('');
    return api(root + 'cart/add.js', { items: items }).then(function () { startTimer(); return refresh(true); })
      .catch(function (e) { refresh(true); err((e && (e.description || e.message)) || NU.tx('Sorry, this item could not be added.')); });
  }
  function addKey(k, q, plan) {
    var p = P[k]; if (!p || !p.id) return;
    q = q || 1;
    var pv = p.v && p.v[q];
    var it = pv ? { id: pv.id, quantity: 1 } : { id: p.id, quantity: q };
    var sp = (pv && pv.sp) || p.sp; if (plan === 'sub' && sp) it.selling_plan = sp;
    add([it]);
  }
  function fromForm() {
    var f = $('buyForm'); if (!f) return;
    var q = f.querySelector('input[name="qty"]:checked'), pl = f.querySelector('input[name="plan"]:checked');
    addKey(CUR, q ? +q.value : 1, pl ? pl.value : 'once');
  }
  function change(line, qty) { return api(root + 'cart/change.js', { line: line, quantity: qty }).then(function (c) { state = c; render(); }); }
  function startTimer() {
    if (!cd || cd.dataset.timer !== 'true' || tEnd) return;
    tEnd = Date.now() + 600000; tick(); tId = setInterval(tick, 1000);
  }
  function tick() {
    var el = $('cdTmV'), box = $('cdTm'); if (!el || !box) return;
    var s = Math.max(0, Math.round((tEnd - Date.now()) / 1000));
    el.textContent = Math.floor(s / 60) + ':' + ('0' + s % 60).slice(-2);
    if (s === 0) { clearInterval(tId); box.classList.add('end'); var sp = box.querySelector('span'); if (sp) sp.textContent = cd.dataset.timerEnd || ''; }
  }
  function up() {
    var L = $('cdUpL'), W = $('cdUp'); if (!L || !W) return;
    var inCart = {}; state.items.forEach(function (x) { var k = keyOf(x); if (k) inCart[k] = 1; });
    var ks = ['hh', 'gum', 'col'].filter(function (k) { return k !== CUR && P[k] && P[k].id && P[k].available && !inCart[k]; });
    L.innerHTML = '';
    ks.forEach(function (k) {
      var u = P[k], d = document.createElement('div'); d.className = 'cd__uc';
      d.innerHTML = '<img src="' + esc(u.img) + '" alt=""><div><b>' + esc(u.short || u.title) + '</b><span>' + esc(u.desc || '') + '</span><em>' + esc(N.money(u.price)) + '</em></div><button type="button" class="cd__ub" data-up="' + k + '">' + NU.tx('+ Add') + '</button>';
      L.appendChild(d);
    });
    W.hidden = state.items.length === 0 || ks.length === 0;
  }
  function render() {
    if (!cd) { setCount(); return; }
    var L = $('cdList'); L.innerHTML = '';
    var n = count();
    state.items.forEach(function (x, i) {
      if (isProt(x)) return;
      var li = document.createElement('li'); li.className = 'cd__it';
      var img = x.image ? x.image.replace(/(\.[a-z]+)(\?|$)/i, '$1$2') : '';
      var sub = [];
      if (x.variant_title && !/default title/i.test(x.variant_title)) sub.push(esc(x.variant_title));
      if (x.selling_plan_allocation) sub.push(esc(renewTxt(x) || x.selling_plan_allocation.selling_plan.name));
      var orig = x.original_line_price, fin = x.final_line_price;
      li.innerHTML = '<img src="' + esc(img) + '" alt="">' + '<div>' + (x.selling_plan_allocation ? '<span class="tag">' + esc(cd.dataset.every || '') + '</span>' : '') +
        '<b>' + esc(x.product_title) + '</b><small>' + sub.join(' · ') + '</small>' +
        '<div class="cd__ln"><span class="cd__q"><button type="button" data-m="' + (i + 1) + '" data-q="' + x.quantity + '" aria-label="' + NU.tx('Remove one') + '">−</button><span>' + x.quantity +
        '</span><button type="button" data-p="' + (i + 1) + '" data-q="' + x.quantity + '" aria-label="' + NU.tx('Add one') + '">+</button></span>' +
        '<span class="cd__pr">' + (orig > fin ? '<s>' + money(orig) + '</s>' : '') + '<b>' + money(fin) + '</b></span></div>' +
        '<button type="button" class="cd__rm" data-r="' + (i + 1) + '">' + NU.tx('Remove') + '</button></div>';
      L.appendChild(li);
    });
    var hasProt = state.items.some(isProt), pt = $('cdPt'); if (pt) pt.checked = hasProt;
    var tot = state.total_price, was = state.original_total_price;
    if ($('cdN')) $('cdN').textContent = n ? '(' + n + ')' : '';
    ['cdShip', 'cdF', 'cdTm', 'cdRev'].forEach(function (id) { var e = $(id); if (e) e.hidden = n === 0; });
    if ($('cdTm') && cd.dataset.timer !== 'true') $('cdTm').hidden = true;
    if ($('cdEmpty')) $('cdEmpty').hidden = n > 0;
    up();
    var need = Math.max(0, (N.freeQty || 2) - n), st = $('cdShipT');
    if (st) st.innerHTML = need === 0 ? (cd.dataset.shipOk || '') : (cd.dataset.shipMore || '').replace('[n]', need);
    if ($('cdBar')) $('cdBar').style.width = (n === 0 ? 0 : Math.min(100, n / (N.freeQty || 2) * 100)) + '%';
    if ($('cdSub')) $('cdSub').textContent = money(tot);
    if ($('cdWas')) $('cdWas').textContent = was - tot > 0 ? money(was) : '';
    if ($('cdGoP')) $('cdGoP').textContent = money(tot);
    if ($('cdSave')) $('cdSave').textContent = money(Math.max(0, was - tot));
    if ($('cdSaveR')) $('cdSaveR').hidden = was - tot <= 0;
    setCount();
  }
  function open() {
    if (!cd) { location.href = root + 'cart'; return; }
    if (cd.classList.contains('on')) return;
    last = document.activeElement; cd.classList.add('on'); cd.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    setTimeout(function () { var x = cd.querySelector('.cd__x'); if (x) x.focus(); }, 50);
  }
  function close() {
    if (!cd) return;
    cd.classList.remove('on'); cd.setAttribute('aria-hidden', 'true'); document.documentElement.style.overflow = '';
    if (last && last.focus) last.focus();
  }
  if (cd) { var pay = document.querySelector('.pay'); if (pay && $('cdPay')) $('cdPay').innerHTML = pay.innerHTML; }
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (cd && t.closest('.cd')) return;
    if (t.closest('[data-cart-open]')) { if (cd) { e.preventDefault(); e.stopPropagation(); refresh(true); } return; }
    if (t.closest('#atc')) { e.preventDefault(); e.stopPropagation(); fromForm(); return; }
    var a = t.closest('[data-add]');
    if (a) { e.preventDefault(); var k = a.getAttribute('data-add') || 'gum'; addKey(k, 1, 'once'); }
  }, true);
  var bf = $('buyForm'); if (bf) bf.addEventListener('submit', function (e) { e.preventDefault(); fromForm(); });
  if (cd) {
    var ptc = $('cdPt');
    if (ptc) ptc.addEventListener('change', function () {
      if (!N.prot) return;
      var idx = -1; state.items.forEach(function (x, i) { if (isProt(x)) idx = i; });
      if (this.checked && idx < 0) api(root + 'cart/add.js', { items: [{ id: N.prot.id, quantity: 1 }] }).then(function () { refresh(); });
      else if (!this.checked && idx >= 0) change(idx + 1, 0);
    });
    cd.addEventListener('click', function (e) {
      var t = e.target, b;
      if (t.closest('[data-cdx]')) { close(); return; }
      if ((b = t.closest('[data-p]'))) { change(+b.dataset.p, +b.dataset.q + 1); return; }
      if ((b = t.closest('[data-m]'))) { change(+b.dataset.m, Math.max(0, +b.dataset.q - 1)); return; }
      if ((b = t.closest('[data-r]'))) { change(+b.dataset.r, 0); return; }
      if ((b = t.closest('[data-up]'))) { addKey(b.dataset.up, 1, 'once'); return; }
      if (t.closest('#cdShop') && $('buyForm')) { e.preventDefault(); close(); $('buyForm').scrollIntoView({ behavior: 'smooth' }); return; }
    });
    addEventListener('keydown', function (e) { if (e.key === 'Escape' && cd.classList.contains('on')) close(); });
  }
  refresh(false).catch(function () {});
})();
